
kiosk_stop_sound = ->
  $(".stop-sound-form").submit ->
    $(this).find("input[type='submit']").hide()
    $(this).find(".loading-div").show()
    $(this).find(".result-msg").html("")

$(document).ready(kiosk_stop_sound)
$(document).on('turbo:load', kiosk_stop_sound)
